<template>
    <select-label
        ref="randomizeTypeRef"
        v-model="type"
        :items="randomizeType"
        :disabled="isDisabled"
        :append-icon="'$vuetify.icons.dropdown'"
        item-text="text"
        item-value="value"
    />
</template>

<script setup lang="ts">
import { toRefs, ref, readonly, computed, watch } from 'vue';
import SelectLabel from './SelectLabel.vue';
import { useTranslation } from '../../composables/translation';
import { AppContext } from '../../store/context';

/**
 * ランダマイズ方式のリストをセレクトボックス用に編集し代入
 */
const { t } = useTranslation();
let randomizeTypeList = AppContext.RandomizeTypeList.map(kv => {
    return {
        text: t(kv.text_key),
        value: kv.value,
    };
});
let randomizeTypeManual = AppContext.RandomizeTypeManual.map(kv => {
    return {
        text: t(kv.text_key),
        value: kv.value,
    };
});

/*
 * properties
 */
interface Props {
    value?: string;
    isSimpleNode?: boolean;
    disabled: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    value: '',
    isSimpleNode: false,
    disabled: false,
});
const { value, isSimpleNode, disabled } = toRefs(props);

/**
 * composables
 */
const type = ref('');
const randomizeTypeRef = ref(null);

/*
 * emits
 */
interface Emits {
    (e: 'input', param: string): void;
}
const emit = defineEmits<Emits>();

/*
 * getter, setter
 */
const isDisabled = readonly(disabled);
const randomizeType = computed(() => {
    return isSimpleNode.value ? randomizeTypeManual : randomizeTypeList;
});

/**
 * methods
 */
function reset(): void {
    randomizeTypeRef.value.reset();
}

/**
 * watchers
 */
watch(
    value,
    (newVal: string) => {
        type.value = newVal;
    },
    { immediate: true }
);
watch(type, (newVal: string) => {
    emit('input', newVal);
});

defineExpose({
    reset,
});
</script>
